import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { FacturaMock, PlayaMock } from '../models/trazabilidad.model';

/** Facturas y camiones en playa. */
export abstract class FacturasDataService {
  abstract facturas(): Observable<FacturaMock[]>;
  abstract playa(): Observable<PlayaMock[]>;
}

/**
 * Implementación real de `FacturasDataService`.
 * Facturas y playa no tienen endpoint en el backend: mientras tanto emite listas vacías, nunca datos mock.
 */
@Injectable()
export class FacturasApiService extends FacturasDataService {
  facturas(): Observable<FacturaMock[]> {
    return of([]);
  }

  playa(): Observable<PlayaMock[]> {
    return of([]);
  }
}
